import { useEffect, useState } from "react";
import Layout from "../../components/Layout/Layout";
import Form from "react-bootstrap/Form";
import FaleAPI from "fale";
import { useDebounce } from "../../hooks/debounce";

const settings = {
  is_live: { label: "Kitchen is live", type: "checked", default: false },
  open: { label: "Kitchen is open", type: "checked", default: false },
  can_deliver: {
    label: "Kitchen can deliver",
    type: "checked",
    default: false,
  },
  can_pickup: { label: "Customer can pickup", type: "checked", default: false },
  notice_period: { label: "Notice period", type: "select", default: "24h" },
  pickup_instructions: { label: "Pickup instructions", type: "textarea" },
};

function Settings(props) {
  const [mapped, setMapped] = useState({});

  useEffect(() => {
    const currentMapped = Object.keys(settings).reduce((s, prop) => {
      const setting = settings[prop];
      return {
        ...s,
        [prop]: props.selectedKitchen?.[prop] || setting.default,
      };
    }, {});
    setMapped(currentMapped);
  }, [props.selectedKitchen]);

  const debounceRequest = useDebounce(() => {
    FaleAPI.kitchens
      .updateSettings(props.selectedKitchen.uuid, mapped)
      .then(() => {
        props.refetchCurrentUser();
      });
  }, 1000);

  const onChange = (key, type) => (e) => {
    const newMapped = {
      ...mapped,
      [key]: type === "checked" ? e.target.checked : e.target.value,
    };
    setMapped(newMapped);

    debounceRequest();
  };

  return (
    <Layout {...props}>
      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <h4>Settings</h4>
        <div className="card mt-3">
          <div className="card-body">
            <div className="row gutters">
              <div className="col-xl-3">
                <div className="row gutters">
                  <div className="settings-block">
                    <div className="settings-block-body">
                      <div className="list-group">
                        {Object.keys(mapped).map((key) => {
                          if (!props.selectedKitchen) return null;
                          const setting = settings[key];

                          if (["textarea", "number"].includes(setting.type))
                            return null;

                          return (
                            <div
                              key={key}
                              className="list-group-item d-flex justify-content-between align-items-center"
                            >
                              <div>{setting.label}</div>
                              <div className="form-switch">
                                {setting.type === "select" && (
                                  <Form.Select
                                    size="sm"
                                    value={mapped[key]}
                                    onChange={onChange(key)}
                                  >
                                    <option value="none">
                                      None (ready immediately or a few minutes)
                                    </option>
                                    <option value="24h">
                                      24 hours (ready on the next day)
                                    </option>
                                    <option value="2d">
                                      2 days (ready in two days)
                                    </option>
                                    <option value="1w">
                                      1 week (ready next week)
                                    </option>
                                  </Form.Select>
                                )}

                                {setting.type === "checked" && (
                                  <input
                                    disabled={
                                      props.selectedKitchen?.status ===
                                        "Pending" && key === "is_live"
                                    }
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={mapped[key]}
                                    onChange={onChange(key, "checked")}
                                  />
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <div className="mb-3">
                        <div className="mb-2">Pickup instructions</div>
                        <textarea
                          value={mapped.pickup_instructions}
                          onChange={onChange("pickup_instructions")}
                          className="form-control"
                          rows="5"
                        ></textarea>
                      </div>
                      <span>Changes will automatically save.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Settings;
